export function recoverTerminalMessage(result: any): string | null {
	// Also protect the UI during an API/frontend rolling deployment.
	if (result?.recoveryStatus === "closed" || result?.pet?.isDeceased) {
		return "This record is closed.";
	}
	if (result?.recoveryStatus === "active" || result?.pet?.chips?.some(
		(chip: any) => chip.isActive || chip.oneTime === true ||
			(chip.expirationDate && new Date(chip.expirationDate).getTime() > Date.now())
	)) {
		return "This record is already active.";
	}
	if (!result?.pet || (result.recoveryStatus && result.recoveryStatus !== "eligible")) {
		return "This record could not be verified. Please contact Peeva support.";
	}
	return null;
}
